import * as React from "react";
import { cn } from "@utils/cn";

const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border border-base-200 bg-white/80 px-3 py-2 text-sm text-base-900 shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-500",
        className
      )}
      ref={ref}
      {...props}
    />
  )
);
Input.displayName = "Input";

export { Input };
